/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useState } from 'react'
import { useGLTF, Html } from '@react-three/drei'
import { useSpring, a } from '@react-spring/three'

import { Select } from '../Form'

import { HOVER_COLOR, PLANE_COLOR, MATERIAL_COLOR } from '../Scene'

export const BUTTONS_FLUSH_SCALE = 0.01
export const BUTTONS_FLUSH_DIMENSIONS = {
	length: 164 * BUTTONS_FLUSH_SCALE,
	width: 100 * BUTTONS_FLUSH_SCALE,
	height: 32 * BUTTONS_FLUSH_SCALE
}

export default function Model({
	enableSelection,
	isSelected,
	onSelect,
	showHhtml = false,
	...props
}) {
	const group = useRef()
	const { nodes } = useGLTF('/Buttons_TG60.gltf')
	// const texture = useTexture('/dot.png')

	const [buttons, setButtons] = useState({ left: false, right: false })
	const [baseHover, setBaseHover] = useState(false)

	const { positionLeftBtn, positionRightBtn } = useSpring({
		positionRightBtn: buttons?.right ? [0, -0.2, 0] : [0, 0, 0],
		positionLeftBtn: buttons?.left ? [0, -0.2, 0] : [0, 0, 0],
		config: { mass: 1, tension: 180, friction: 16, precision: 0.0001 }
	})

	const handleButtonPress = (button) => {
		setButtons((prevBtn) => ({
			[button]: !prevBtn[button]
		}))
	}

	return (
		<group ref={group} {...props} dispose={null}>
			<a.mesh
				onClick={() => handleButtonPress('left')}
				geometry={nodes.Button_Left.geometry}
				position={positionLeftBtn}
				rotation={[Math.PI / 2, 0, 0]}
				scale={BUTTONS_FLUSH_SCALE}
				receiveShadow
				castShadow>
				<meshStandardMaterial
					attach="material"
					color={isSelected ? '#FF3D00' : MATERIAL_COLOR}
					//map={texture}
				/>
			</a.mesh>
			<a.mesh
				onClick={() => handleButtonPress('right')}
				geometry={nodes.Button_Right.geometry}
				position={positionRightBtn}
				rotation={[Math.PI / 2, 0, 0]}
				scale={BUTTONS_FLUSH_SCALE}
				receiveShadow
				castShadow>
				<meshStandardMaterial
					attach="material"
					color={isSelected ? '#FF3D00' : MATERIAL_COLOR}
				/>
			</a.mesh>
			<mesh
				geometry={nodes.Base.geometry}
				rotation={[Math.PI / 2, 0, 0]}
				scale={BUTTONS_FLUSH_SCALE}
				receiveShadow
				castShadow
				onPointerOver={(e) => setBaseHover(true)}
				onPointerOut={(e) => setBaseHover(false)}
				onClick={() => onSelect()}>
				<meshStandardMaterial
					attach="material"
					color={
						enableSelection
							? isSelected
								? PLANE_COLOR
								: baseHover
								? HOVER_COLOR
								: PLANE_COLOR
							: PLANE_COLOR
					}
				/>
			</mesh>
			{showHhtml && (
				<Html
					className="content"
					// rotation-x={-Math.PI / 2}
					position={[-0.75, 0.4, -0.5]}
					rotation-x={Math.PI * 0.5}
					rotation-y={Math.PI * 1}
					transform
					occlude>
					<div className="wrapper">
						<Select
							state={
								buttons.left
									? 'b'
									: buttons.right
									? 'a'
									: 'default'
							}
						/>
					</div>
				</Html>
			)}
		</group>
	)
}

useGLTF.preload('/Buttons_TG60.gltf')
